import ThePageTitle from './ThePageTitle.vue'

export { ThePageTitle }
export default ThePageTitle
